var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-not-allowed"},[_vm._v(" Your not allowed to access this page. "),_c('a',{staticClass:"link",on:{"click":function($event){return _vm.$router.go(-2)}}},[_vm._v("Go back")])])}
var staticRenderFns = []

export { render, staticRenderFns }